import React from "react";

// Jun 2026 (Randy) — circular "badge" listen button: an icon-only colored disc
// with its label curved over the TOP and under the BOTTOM (like a stamp), plus a
// straight plain-text label underneath. Sized ~20% smaller than the original
// with the curved text hugging the disc (bottom sits a touch lower than top).
// SVG text is pointer-events:none so the whole disc stays clickable.
export const CurvedListenButton = ({
  id,
  topLabel,
  bottomLabel,
  straightLabel,
  color,
  icon,
  disabled = false,
  onClick,
  testid,
  labelColor = "#1C1B1A",
  accessory = null,
  square = false,
  warming = false,
}) => {
  const topId = `lane-top-${id}`;
  const botId = `lane-bot-${id}`;
  // viewBox 80, center 40, disc r=21.5 (43px). Top text arc r=23 (hugs the disc);
  // bottom text arc r=26 (sits a little lower than the top, per the mock).
  const textStyle = { fontSize: "8px", fontWeight: 700, letterSpacing: "0.3px" };
  return (
    <div className="flex flex-col items-center" style={{ width: 96 }}>
      <div className="relative" style={{ width: 96, height: 96 }}>
        <button
          type="button"
          data-testid={testid}
          disabled={disabled}
          onClick={onClick}
          className={`group relative w-full h-full flex items-center justify-center ${disabled ? "cursor-default" : ""}`}
        >
          <svg
            viewBox="0 0 80 80"
            className="absolute inset-0 w-full h-full pointer-events-none"
            style={{ opacity: disabled ? 0.5 : 1 }}
          >
            <defs>
              <path id={topId} d="M 14,40 A 26,26 0 0 1 66,40" fill="none" />
              <path id={botId} d="M 8,40 A 32,32 0 0 0 72,40" fill="none" />
            </defs>
            <text fill={labelColor} style={textStyle}>
              <textPath href={`#${topId}`} startOffset="50%" textAnchor="middle">
                {String(topLabel).toUpperCase()}
              </textPath>
            </text>
            <text fill={labelColor} style={textStyle}>
              <textPath href={`#${botId}`} startOffset="50%" textAnchor="middle">
                {String(bottomLabel).toUpperCase()}
              </textPath>
            </text>
          </svg>
          <span
            className={`relative ${square ? "rounded-2xl" : "rounded-full"} flex items-center justify-center text-white shadow-sm transition-transform duration-200 ${warming ? "voice-warming" : ""} ${
              disabled ? "opacity-50" : "group-hover:scale-105 group-hover:shadow-md"
            }`}
            style={{ width: 52, height: 52, background: color }}
          >
            {icon}
          </span>
        </button>
        {accessory}
      </div>
      {straightLabel && (
        <div className="w-full text-center text-[12px] font-semibold leading-none mt-0.5 whitespace-nowrap" style={{ color: "var(--tpl-text, #1C1B1A)" }}>
          {straightLabel}
        </div>
      )}
    </div>
  );
};

export default CurvedListenButton;
